import http from "../http";
import Service from "../../Service";

const LONG_TIMEOUT = 600000;

export default class QuotationDraftService extends Service {

    create(data = {}) {
        return http.post('clients/quotation-drafts', data, {
            headers: this.getHeaders(),
            timeout: LONG_TIMEOUT
        });
    }

    update(id, data) {
        return http.patch(`clients/quotation-drafts/${id}`, data, { headers: this.getHeaders() });
    }

    discard(id) {
        return http.delete(`clients/quotation-drafts/${id}`, { headers: this.getHeaders() });
    }

    saveItems(id, items) {
        return http.put(`clients/quotation-drafts/${id}/items`, { items }, {
            headers: this.getHeaders(),
            timeout: LONG_TIMEOUT
        });
    }

    participants(id) {
        return http.get(`clients/quotation-drafts/${id}/participants`, {
            headers: this.getHeaders(),
            timeout: LONG_TIMEOUT
        });
    }

    saveParticipants(id, selection) {
        return http.put(`clients/quotation-drafts/${id}/participants`, selection, { headers: this.getHeaders() });
    }

    send(id) {
        return http.post(`clients/quotation-drafts/${id}/send`, {}, {
            headers: this.getHeaders(),
            timeout: LONG_TIMEOUT
        });
    }

}

export function quotationDraftErrorMessage(error, fallback = 'Não foi possível enviar a cotação.') {
    const data = error?.response?.data;

    if (Array.isArray(data?.errors) && data.errors.length > 0) {
        return data.errors[0];
    }

    if (data?.errors && typeof data.errors === 'object') {
        const firstFieldErrors = Object.values(data.errors)[0];

        return Array.isArray(firstFieldErrors) ? firstFieldErrors[0] : data.message || fallback;
    }

    return data?.message || fallback;
}
